export class ServiceFamily {
  public Id: number = 0;
  public Name: string = "";
  public Sort: number = 0;
}
